import { FuseAnimate, FusePageCarded } from '@fuse';
import _ from '@lodash';
import { Typography, withStyles } from '@material-ui/core';
import XAPPAcoesTela from 'app/Core/Components/AcoesTela/XAPPAcoesTela';
import FilterApp from 'app/Core/Components/Filter/FilterApp';
import PainelToggleButton from 'app/Core/Components/Filter/PainelToggleButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import ConteudoDialog from './ConteudoDialog';
import ConteudoList from './ConteudoList';
import * as Actions from './Store/Actions/ConteudoActions';
import reducer from './Store/Reducers/ConteudoReducer';

const filterApp = [
    { "label": "Descrição", "value": "conteudo.descricao", "tipo": "string" },
    { "label": "Código", "value": "conteudo.titulo", "tipo": "string" }
];

const TIPOS = [
    { "id": 1, "label": "Ajuda" },
    { "id": 2, "label": "Get start" }
];

const GRUPOS = [
    {
        "id": 100, "label": "Cadastro", "categorias": [
            { "id": 1001, "label": "Pessoas" },
            { "id": 1002, "label": "Tags" },
            { "id": 1003, "label": "Departamentos" },
            { "id": 1004, "label": "Locais" },
            { "id": 1005, "label": "Produtos" },
            { "id": 1006, "label": "Grupos de produto" },
            { "id": 1007, "label": "Depósitos" },
            { "id": 1008, "label": "Contas" },
            { "id": 1009, "label": "Categorias" },
            { "id": 1010, "label": "Relatórios" }
        ]
    },
    {
        "id": 200, "label": "Suprimentos", "categorias": [
            { "id": 2001, "label": "Estoque" },
            { "id": 2002, "label": "Inventário" },
            { "id": 2003, "label": "Compras" },
            { "id": 2004, "label": "Relatórios" }
        ]
    },
    {
        "id": 300, "label": "Financeiro", "categorias": [
            { "id": 3001, "label": "Conferência de caixa" },
            { "id": 3002, "label": "DRE" },
            { "id": 3003, "label": "Contas a pagar" },
            { "id": 3004, "label": "Contas a receber" },
            { "id": 3005, "label": "Faturamento" },
            { "id": 3006, "label": "Extrato" },
            { "id": 3007, "label": "Relatórios" }
        ]
    },
    {
        "id": 400, "label": "Atendimento", "categorias": [
            { "id": 4001, "label": "Atendimentos" },
            { "id": 4002, "label": "Prontuário" },
            { "id": 4003, "label": "Relatórios" }]
    },
    {
        "id": 500, "label": "Agendamento", "categorias": [
            { "id": 5001, "label": "Fechamento de caixa" },
            { "id": 5002, "label": "Agendamentos" },
            { "id": 5003, "label": "Relatórios" }
        ]
    },
    {
        "id": 600, "label": "Outros", "categorias": [
            { "id": 6001, "label": "Arquivo" },
            { "id": 6002, "label": "Home" },
            { "id": 6003, "label": "Meu perfil" },
        ]
    }
];

const styles = theme => ({
    addButton: {
        position: 'absolute',
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

class ConteudoApp extends XAPPComponent {

    state = {
        acoes: null
    }

    getAcoes = (_AValue) => {
        return this.state.acoes;
    }

    setAcoes = (_AValue) => {
        this.setState({ acoes: _AValue });
    }

    listFilter = (_AFilter) => {
        const { tipo = null } = this.props;
        const xappRouteParams = this.props.match.params;
        let AFiltro = Object.assign({}, _AFilter);
        if (_.isUndefined(AFiltro.AND) || _.isNull(AFiltro.AND)) {
            AFiltro.AND = [];
        }
        if (!_.isNull(tipo)) {
            AFiltro.AND.push({ Campo: "tipo", Operador: "=", Valor: tipo });
        }
        this.props.list("SELECIONAR", xappRouteParams, AFiltro);
    }

    render() {
        const xappRouteParams = this.props.match.params;
        const { acoes } = this.state;
        const { Label, tipo = null } = this.props;

        return (
            <React.Fragment>
               
                    <FusePageCarded
                        classes={{
                            contentWrapper: "p-0",
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: "w-256 border-0",
                            header: "w-full min-h-48 h-48 max-h-48 flex",
                            topBg: "min-h-48 h-48"
                        }}
                        header={
                            <div className="w-full flex items-center">
                                <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                    <Typography className=" sm:flex text-white" variant="h6">{Label}</Typography>
                                </FuseAnimate>
                                <div className="flex-1" />
                                <PainelToggleButton />
                                <FilterApp
                                    filters={filterApp}
                                    xappRouteParams={xappRouteParams}
                                    pesquisar={this.listFilter}
                                />
                            </div>
                        }
                        content={
                            <ConteudoList
                                xappRouteParams={xappRouteParams}
                                setAcoes={this.setAcoes}
                                getAcoes={this.getAcoes}
                                tipo={tipo}
                                listFilter={this.listFilter}
                            />
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                    {acoes !== null &&
                        <XAPPAcoesTela>
                            {acoes}
                        </XAPPAcoesTela>
                    }
                    <ConteudoDialog
                        xappRouteParams={xappRouteParams}
                        tipo={tipo}
                        TIPOS={TIPOS}
                        GRUPOS={GRUPOS}
                    />
                   
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
    }, dispatch);
}

function mapStateToProps({ Conteudo }) {
    return {
        Conteudo: Conteudo,
    }
}

export default withReducer('Conteudo', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ConteudoApp))));
